import axios from 'axios';
import { API_ORIGIN } from './config';

const BASE_URL = `${API_ORIGIN}/api/explore`;

const log = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('[exploreApi]', ...args);
  }
};

const normalizeTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags)) {
    return tags.map((tag) => String(tag).trim()).filter(Boolean);
  }
  if (typeof tags === 'string') {
    return tags
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
  return [];
};

export const fetchExplorePosts = async (params = {}) => {
  log('GET', BASE_URL, params);
  const res = await axios.get(BASE_URL, { params });
  return res.data?.data ?? [];
};

export const createExplorePost = async (payload) => {
  const data = { ...payload, tags: normalizeTags(payload.tags) };
  log('POST', BASE_URL, data);
  const res = await axios.post(BASE_URL, data);
  return res.data?.data;
};

export const updateExplorePost = async (id, payload) => {
  const url = `${BASE_URL}/${id}`;
  const data = { ...payload, tags: normalizeTags(payload.tags) };
  log('PUT', url, data);
  const res = await axios.put(url, data);
  return res.data?.data;
};

export const deleteExplorePost = async (id) => {
  const url = `${BASE_URL}/${id}`;
  log('DELETE', url);
  const res = await axios.delete(url);
  return res.data?.data;
};

export default {
  fetchExplorePosts,
  createExplorePost,
  updateExplorePost,
  deleteExplorePost,
};
